import type { Requests } from "../common/request.common";
import type { FeatureTogglesResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const featureToggles = {
    obtain(group: string) {
        return get<FeatureTogglesResponseTypes.Obtain>(`/features/obtain/${group}`);
    },
    update(group: string, data: typeof Requests.FeatureToggles.Data.Input) {
        return post<typeof data>(`/features/update/${group}`, data);
    },
};
